import { render, staticRenderFns } from "./hotelDetail.vue?vue&type=template&id=f1f97bf8&"
import script from "./hotelDetail.vue?vue&type=script&lang=ts&"
export * from "./hotelDetail.vue?vue&type=script&lang=ts&"
import style0 from "./hotelDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports